import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import './css/barista-mobile.css';
import './css/mediaquery.css';
import './fonts/stylesheet_roboto.css';
import './fonts/all.min.css';

// pages
import Landing from './pages/Landing';
import Feedback from "./pages/Feedback";
import MenuSub from "./pages/MenuSub";
import Menu from "./pages/Menu";
import FoodList from "./pages/FoodList";
import Registration from "./pages/Registration";
// pages

function App() {
  return(
    <Router>
      <Routes>
        <Route path="/" element={<Landing/>} />
        <Route path="/menu" element={<Menu/>} />
        <Route path="/feedback" element={<Feedback/>} />
        <Route path="/menu-sub" element={<MenuSub/>} />
        <Route path="/food-list" element={<FoodList/>} />
        <Route path="/registration" element={<Registration/>} />
      </Routes>
    </Router>
  )
}

export default App;
